import { Component } from '@angular/core';

@Component({
  selector: 'tun-search-result-song-icon-v5',
  templateUrl: './search-result-song-icon-v5.component.html',
  styleUrls: ['./search-result-song-icon-v5.component.scss']
})
export class SearchResultSongIconV5Component {

}
